import React, { Dispatch, ReactNode, SetStateAction } from "react";
import "./ActionRow.scss";
import { Model } from "react-3layer-common";
export interface ActionRowType<T extends Model> {
  record?: T;
  visible?: boolean;
  x?: number;
  y?: number;
  rowHeight?: number;
}
export interface ActionRowProps<T extends Model> {
  children?: ReactNode;
  tableKey?: string;
  actionRow?: ActionRowType<T>;
  setActionRow?: Dispatch<SetStateAction<ActionRowType<T>>>;
}

const ActionRow = (props: ActionRowProps<Model>) => {
  const { actionRow, setActionRow, children, tableKey } = props;

  const [topTable, setTopTable] = React.useState<number>(0);

  React.useEffect(() => {
    const table = document.getElementById(tableKey);
    const tableContent =
      table.getElementsByClassName("ant-table-content")[0] ||
      table.getElementsByClassName("ant-table-body")[0];
    const topTableTmp = table?.getBoundingClientRect().top;
    tableContent.addEventListener("mouseleave", () => {
      setActionRow({ visible: false });
    });
    setTopTable(topTableTmp);
    return () => {
      tableContent.removeEventListener("mouseleave", () => {
        setActionRow({ visible: false });
      });
    };
  }, [tableKey, setActionRow, setTopTable]);

  return actionRow?.visible ? (
    <ul
      className="action-row"
      style={{
        right: `${actionRow?.x}px`,
        top: `${actionRow?.y - topTable}px`,
        height: `${actionRow?.rowHeight}px`,
      }}
      onMouseOver={() => {
        setActionRow({ ...actionRow, visible: true });
      }}
      onMouseLeave={() => {
        setActionRow({ ...actionRow, visible: false });
      }}
    >
      {children}
    </ul>
  ) : (
    <></>
  );
};
export default ActionRow;
